export const environmentBase = {
  cloudRun: {},
};
